

























import {
  defineComponent,
} from '@vue/composition-api';

import useAuth from '@/useAuth';

import { expense as expenseStatus } from '@/status';

const AppCPT = defineComponent({
  setup() {
    const { me, isLoggedIn, hasPermission } = useAuth();

    return {
      expenseStatus,
      me,
      isLoggedIn,
      hasPermission,
    };

    // return {
    //   myInfo,
    // };
  },
});

export default AppCPT;
